import {Contract, Entity} from 'interactors/contracts/types';

export function applyContract(entity: Entity, method: string, contract: Contract): Entity {
  const originalMethod = entity[method];

  entity[method] = function ensureAndDo(...args: unknown[]): void {
    contract.require(...args);
    originalMethod(...args);
    contract.ensure(...args);
  };

  return entity;
}
